export default "__VITE_PUBLIC_ASSET__03b80d4f__"